import { Chip } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface IndicatorFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

const INDICATOR_COLORS: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
  green: 'success',
  yellow: 'warning',
  red: 'error',
}

export function IndicatorField({ field, value, mode }: IndicatorFieldProps) {
  const strVal = value != null ? String(value) : ''
  const color = INDICATOR_COLORS[strVal.toLowerCase()] ?? 'default'

  if (mode === 'edit') {
    return <Chip label={strVal || field.label} color={color} size="small" />
  }

  return <Chip label={strVal || field.label} color={color} size="small" variant="outlined" />
}
